export default __webpack_public_path__ + "static/media/ic_map_white_24px.97e20a39.svg";